import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useTinyMCEStore = defineStore('tinyMCE', () => {
    const isModalOpen = ref<boolean>(false);
    const currentContent = ref<string>('');
    const currentFieldKey = ref<string>('');
    const updateCallback = ref<((content: string) => void) | null>(null);
    const isEditorReady = ref<boolean>(false);

    const openEditor = (content: string, fieldKey: string, callback: (content: string) => void) => {
        currentContent.value = content;
        currentFieldKey.value = fieldKey;
        updateCallback.value = callback;
        isModalOpen.value = true;
    };

    const closeEditor = () => {
        isModalOpen.value = false;
        currentFieldKey.value = '';
        updateCallback.value = null;
    };

    const saveContent = (content: string) => {
        if (updateCallback.value) {
            updateCallback.value(content);
        }
        currentContent.value = content;
    };

    const setEditorReady = (ready: boolean) => {
        isEditorReady.value = ready;
    };

    return {
        isModalOpen,
        currentContent,
        currentFieldKey,
        isEditorReady,
        openEditor,
        closeEditor,
        saveContent,
        setEditorReady,
    };
});
